export default __webpack_public_path__ + "1ee426d.png";